<!-- Start Page Title Area -->
<div id="bg-cover" class="page-title-area lightgray-bg jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">{{home}}</a></li>
                <li>{{dictionary}}</li>
            </ul>
            <h2>{{dictionary}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<section class="pt-100">
    <div class="container">
        <app-search-box [searchedItems]="searchWordsResult" [placeholder]="searchWord" (onSearch)="onSearchWords($event)" (onSelectWord)="onSelectWord($event)"></app-search-box>
    </div>

</section>

<section id="word-detail">
    <app-word-detail [showShimmer]="showShimmerWord" [word]="word"></app-word-detail>
</section>

<!-- Start Contact Info Area -->
<section class="pt-50">

    <div class="container no-hover">
        <div class="row">
            <div class="col align-self-stretch tile-outer">
                <div class="contact-info-box mb-30 orange-bg-div static-div">
                    <div class="tile">
                        <div>
                            <div class="text">
                                {{welcomeTo}}
                            </div>
                            <p class="mt-2">{{welcomeToText}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-6 align-self-stretch tile-outer">
                <div class="contact-info-box mb-30 blue-bg-div static-div">
                    <div class="tile">
                        <div>
                            <div class="text">
                                {{wordOf}}
                            </div>
                            <p class="mt-2">{{wordOfText}}</p>
                        </div>
                    </div>
                </div>
            </div> -->

        </div>
    </div>

    <!-- <div id="particles-js-circle-bubble-2"></div> -->
</section>
<!-- End Contact Info Area -->

<section class="mt-4 mb-4">
    <div class="container">
        <div class="row">

            <div class="col-lg-4 col-md-6 col-sm-6 link-item" *ngFor="let link of links">
                <a target="_blank" class="article-link" href="{{link.link}}">
                    <div class="contact-info-box article mb-30">
                        <div class="tile">
                            <div>
                                <div class="icon no-hover">
                                    <img src="{{link.imageUrl}}" alt="">
                                </div>
                                <div class="text">
                                    {{link.title}}
                                </div>
                                <p class="mt-2">{{link.description}}</p>
                            </div>
                        </div>
                    </div>
                </a>
            </div>

            <!--Shimmer Items-->
            <div class="col-lg-4 col-md-6 col-sm-6 shimmer-link-items">
                <a target="_blank" class="article-link" href="#">
                    <div class="contact-info-box article mb-30 shimmer-container">
                        <div class="tile">
                            <div>
                                <div class="icon shimmerBG"></div>
                                <div class="text">
                                    <div class="shimmerBG title-line"></div>
                                </div>
                                <div class="mt-2">
                                    <div class="shimmerBG content-line"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 shimmer-link-items">
                <a target="_blank" class="article-link" href="#">
                    <div class="contact-info-box article mb-30 shimmer-container">
                        <div class="tile">
                            <div>
                                <div class="icon shimmerBG"></div>
                                <div class="text">
                                    <div class="shimmerBG title-line"></div>
                                </div>
                                <div class="mt-2">
                                    <div class="shimmerBG content-line"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 shimmer-link-items">
                <a target="_blank" class="article-link" href="#">
                    <div class="contact-info-box article mb-30 shimmer-container">
                        <div class="tile">
                            <div>
                                <div class="icon shimmerBG"></div>
                                <div class="text">
                                    <div class="shimmerBG title-line"></div>
                                </div>
                                <div class="mt-2">
                                    <div class="shimmerBG content-line"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>

        </div>
    </div>

</section>

<section class="mt-4 pb-70 books">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">{{findOutMore}}</span>
        </div>

        <div class="row">
            
            <div class="col-lg-4 col-md-6 col-sm-6 align-self-stretch tile-outer book-item" *ngFor="let book of books">
                <div class="container-fluid d-flex flex-xl-row flex-column book-content">

                    <div class="bloc_1 shimmerBG">
                        <img src="{{book.imageUrl}}" alt="">
                    </div>

                    <div class="bloc_2">
                        <div class="d-flex flex-column">
                            <div>
                                <p>{{book.name}}</p>
                            </div>
                            <div class="float-bottom">
                                <a target="_blank" href="{{book.link}}" class="default-btn">{{buyThisBook}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6 col-sm-6 align-self-stretch tile-outer mb-3 shimmer-book-items">
                <div class="container-fluid d-flex flex-xl-row flex-column book-content shimmer-container">

                    <div class="bloc_1 shimmerBG">
                        <img src="/assets/img/book-cover.png" alt="">
                    </div>

                    <div class="bloc_2">
                        <div class="d-flex flex-column">
                            <div class="shimmerBG title-line">
                            </div>
                            <div class="float-bottom shimmer-div">
                                <a routerLink="/contact" class="default-btn">{{buyThisBook}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 align-self-stretch tile-outer mb-3 shimmer-book-items">
                <div class="container-fluid d-flex flex-xl-row flex-column book-content shimmer-container">

                    <div class="bloc_1 shimmerBG">
                        <img src="/assets/img/book-cover.png" alt="">
                    </div>

                    <div class="bloc_2">
                        <div class="d-flex flex-column">
                            <div class="shimmerBG title-line">
                            </div>
                            <div class="float-bottom shimmer-div">
                                <a routerLink="/contact" class="default-btn">{{buyThisBook}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 align-self-stretch tile-outer mb-3 shimmer-book-items">
                <div class="container-fluid d-flex flex-xl-row flex-column book-content shimmer-container">

                    <div class="bloc_1 shimmerBG">
                        <img src="/assets/img/book-cover.png" alt="">
                    </div>

                    <div class="bloc_2">
                        <div class="d-flex flex-column">
                            <div class="shimmerBG title-line">
                            </div>
                            <div class="float-bottom shimmer-div">
                                <a routerLink="/contact" class="default-btn">{{buyThisBook}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
           
        </div>
    </div>

</section>

<!-- <div class="card">
    <div class="shimmerBG media"></div>
    <div class="p-32">
        <div class="shimmerBG title-line"></div>
        <div class="shimmerBG title-line end"></div>

        <div class="shimmerBG content-line m-t-24"></div>
        <div class="shimmerBG content-line"></div>
        <div class="shimmerBG content-line"></div>
        <div class="shimmerBG content-line"></div>
        <div class="shimmerBG content-line end"></div>
    </div>
</div> -->